<template>
  <search-group title=" " @search="findData" @clear="clearValue"
                :span="24" :inline="true" :multipleLines="true" :btnOffset="18" :btnSpan="6">
    <Row :gutter="24" class="mb16">
      <Col span="6">
        <Select v-model="searchData.projectFid" @on-change="changeProject" placeholder="项目名称">
          <Option value="">请选择</Option>
          <Option value="100" v-for="item in projectList" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
      </Col>
      <Col span="6">
        <Select v-model="searchData.zoFid" placeholder="请选择zo">
          <Option value="">{{searchData.projectFid==='' ? '请先选择项目':'请选择'}}</Option>
          <Option value="100" v-for="(item,i) in zoList" :value="item.value" :key="item.value+i">{{item.text}}</Option>
        </Select>
      </Col>
      <Col span="6">
        <Select v-model="searchData.houseTypeFid" placeholder="房型名称">
          <Option value="">{{searchData.projectFid==='' ? '请先选择项目':'请选择'}}</Option>
          <Option v-for="item in houseTypeList" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
      </Col>
      <Col span="6">
        <Select v-model="searchData.remindStatus" placeholder="有房提醒状态">
          <Option value="">请选择</Option>
          <Option value="100" v-for="item in remindStatusList" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
      </Col>
    </Row>
    <Row :gutter="24"  style="margin-bottom: 42px">
      <Col span="6">
        <Select v-model="searchData.isSignContract" placeholder="是否签约">
          <Option value="">请选择</Option>
          <Option value="100" v-for="item in signStatusList" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
      </Col>
      <Col span="6">
        <DatePicker class="block" type="daterange" split-panels placeholder="创建日期" v-model="createTimeDate" @on-change="getCreateTime"></DatePicker>
      </Col>
      <Col span="6">
        <DatePicker class="block" type="daterange" split-panels placeholder="系统触发提醒时间" v-model="triggerReminderTimeDate" @on-change="getTriggerReminderTime"></DatePicker>
      </Col>
      <Col span="6" >
        <Input placeholder="请输入客户姓名或电话" v-model="searchData.customerInfo" @keyup.enter.native="findData"></Input>
      </Col>
    </Row>
  </search-group>
</template>

<script type="text/ecmascript-6">
  import {getProjects, getProjectZos} from 'api/common'
  import SearchGroup from 'components/SearchGroup/index';
  import {getHouseType} from "api/house";
  import {selectCondition} from "api/roomRemind";

  export default {
    created() {
      this.initData()
    },
    props: {
    },
    watch: {
    },
    components: {
      SearchGroup
    },
    data() {
      return {
        loading: false,
        searchData: {
          projectFid: '',
          houseTypeFid: '',
          remindStatus: '',
          isSignContract: '',
          customerInfo: '',
          createTimeFrom: '',
          createTimeTo: '',
          triggerReminderTimeFrom: '',
          triggerReminderTimeTo: '',
          endTimeFrom: '',
          endTimeTo: '',
          zoFid: '',
          page: 1,
          limit: 10
        },
        zoList: [],
        projectList:[],
        houseTypeList: [],
        createTimeDate:[],
        triggerReminderTimeDate:[],
        remindStatusList:[],
        signStatusList:[],
      }
    },
    methods: {
      findData() {
        this.$emit('findData', this.searchData);
      },
      getCreateTime(val){
        this.searchData.createTimeFrom = val[0]
        this.searchData.createTimeTo = val[1]
      },
      getTriggerReminderTime(val){
        this.searchData.triggerReminderTimeFrom = val[0]
        this.searchData.triggerReminderTimeTo = val[1]
      },
      clearValue() {
        this.searchData= {
            projectFid: '',
            houseTypeFid: '',
            remindStatus: '',
            isSignContract: '',
            customerInfo: '',
            createTimeFrom: '',
            createTimeTo: '',
            triggerReminderTimeFrom: '',
            triggerReminderTimeTo: '',
            endTimeFrom: '',
            endTimeTo: '',
            page: 1,
            limit: 10
        }
        this.createTimeDate=[]
        this.triggerReminderTimeDate=[]
      },
      changeProject(value) {
        if (value !== '') {
          this.getProjectZos(value)
          this.getHouseTypeListByProFid(value)
        } else {
          this.zoList = []
          this.houseTypeList = []
        }
      },
      getProjectZos(projectFid) {
        getProjectZos(projectFid).then(res => {
          this.zoList = res.data
        })
      },
      getHouseTypeListByProFid(projectFid) {
        getHouseType(projectFid).then(res => {
          this.houseTypeList = res.data.houseTypeList
        })
      },
      initData(){
        getProjects().then( res=> {
          this.projectList = res.data
        })
        selectCondition().then( res => {
          this.remindStatusList = res.data.remindStatus
          this.signStatusList = res.data.signStatus
        })
        this.$emit('findData',this.searchData)
      },
    }
  }
</script>
<style scoped>
  .flex {
    display: block;
  }
  .search-wrapper {
    /*padding: 24px 0 !important;*/
  }

  .width200 {
    width: 200px;
  }

  .width300 {
    width: 300px;
  }

  .block {
    display: block;
  }
</style>

